import axios from "axios";
import vue from "vue";
import '../i18n'

let country = localStorage.getItem("Content-Country");
let city = localStorage.getItem("Content-City");
if (country !== null && city !== null) {
  //  
} else {
  // COUNTRY
  const countryDefault = { label: "Switzerland", value: 214, iso: 'ch' };
  localStorage.setItem("Content-Country", JSON.stringify(countryDefault));
  // CITY
  const cityDefault = { label: "Aadorf", value: 17356 };
  localStorage.setItem("Content-City", JSON.stringify(cityDefault));
}

const API_ENDPOINT = process.env.VUE_APP_API_URL
const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    accept: "application/json",
    "Content-Type": "application/json",
  },
});

client.defaults.withCredentials = true;

class ServiceApi {
  static getCookie() {
    return client({
      method: "GET",
      url: "/sanctum/csrf-cookie",
    });
  }

  static get(path = "", params = {}) {
    return client.get(path, { params });
  }

  static post(path = "", data = {}, optionalHeader = {}) {
    return client({
      method: "POST",
      url: path,
      data,
      headers: { ...optionalHeader },
    });
  }

  static patch(path = "", data = {}) {
    return client({
      method: "PATCH",
      url: path,
      data: JSON.stringify(data),
    });
  }

  static delete(path = "", data = {}) {
    return client({
      method: "DELETE",
      url: path,
      data: JSON.stringify(data),
    });
  }

  static put(path = "", data = {}) {
    return client({
      method: "PUT",
      url: path,
      data: JSON.stringify(data),
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers };
  requestConfig.headers['Content-Language'] = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
  requestConfig.headers['Content-Country'] = JSON.parse(country).value
  requestConfig.headers['Content-City'] = JSON.parse(city).value

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    const originalRequest = error.config;
    if (response) {
      if (response.status === 500) {
        vue.$toast.error(error.response.statusText, {
          position: "top-right"
        })
      } else if (response.status === 422) {
        const {data: { data }} = response;
        if(data === null){
          vue.$toast.error(response.data.message, {
            position: "top-right"
          })
        }
        Object.values(data).forEach((error) => {
          vue.$toast.error(error, {
            position: "top-right"
          })
        });
      } else if (response.status === 403) {
        vue.$toast.error(response.data.message, {
          position: "top-right"
        })
      } else if (response.status === 404) {
        vue.$toast.error(response.data.message, {
          position: "top-right"
        })
      } else if (response.status === 409) {
        vue.$toast.error(response.data.error, {
          position: "top-right"
        })
      } else {
        return originalRequest;
      }
    }
    return Promise.reject(error);
  }
);
export { ServiceApi };
